<template>
	<div class="dashboard-menu__icon col-lg-2 col-md-4 col-6">
		<template v-if="menuLink">
			<router-link :to="'/'+formatToPath(moduleName)" class="icon-box">
				<div class="icon-box__container">
					<img class="icon-box__img" :src="'images/module-icons/'+moduleIcon+'.svg'">
					<p class="icon-box__name">{{moduleName}}</p>
				</div>
			</router-link>
		</template>
		<template v-else>
			<a href="javascript:void(0);" class="icon-box" @click="moduleIconClicked">
				<div class="icon-box__container">
					<img class="icon-box__img" :src="'images/module-icons/'+moduleIcon+'.svg'">
					<p class="icon-box__name">{{moduleName}}</p>
				</div>
			</a>
		</template>
	</div>
</template>

<script>
// @ is an alias to /src
import { EventBus } from '@/event-bus.js'

	export default {
		name: 'MenuBox',
		props: {
			menuLink: Boolean,
			moduleName: String,
			moduleIcon: String,
			modulePages: Array
		},
		data() {
			return {

			}
		},
		methods: {
			moduleIconClicked: function() {
				// Show Menu Modal
				EventBus.$emit('show-menu-modal',this.moduleName,this.modulePages);
			}
		}
	}
</script>